var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 26.6667H22.6667M12 21.3333V26.6667M20 21.3333V26.6667M10.6667 16L14.6667 12L17.3333 14.6667L21.3333 10.6667M4 6.66666C4 6.31304 4.14048 5.9739 4.39052 5.72385C4.64057 5.4738 4.97971 5.33333 5.33333 5.33333H26.6667C27.0203 5.33333 27.3594 5.4738 27.6095 5.72385C27.8595 5.9739 28 6.31304 28 6.66666V20C28 20.3536 27.8595 20.6928 27.6095 20.9428C27.3594 21.1929 27.0203 21.3333 26.6667 21.3333H5.33333C4.97971 21.3333 4.64057 21.1929 4.39052 20.9428C4.14048 20.6928 4 20.3536 4 20V6.66666Z",
    stroke: "#F16434",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.cc4b853e95b7e450b66cc353847c0120.svg";
export { ForwardRef as ReactComponent };